module.exports = __webpack_public_path__ + "static/Home1IN-7504f15724ab0a5462ed385c38fced8d.png";